import React, { memo } from 'react';
import Button from '@snapp/ui-kit/Box';
import Layout from '@snapp/ui-kit/Layout';
import LayoutFooter from '@snapp/ui-kit/LayoutFooter';
import LayoutMain from '@snapp/ui-kit/LayoutMain';
import Text from '@snapp/ui-kit/Text';
import PropTypes from 'prop-types';
import s from './splash-screen.module.css';
import Image from '@/components/image';
import t from '@/i18n';

function SplashScreen({ showTryAgain, onTryAgain }) {
  return (
    <Layout _color="primary" className={s.content} height="100%">
      <LayoutMain className={s.main}>
        <div className={s.logo}>
          <Image
            width="119"
            src={`logos/${process.env.REACT_APP_BRAND}-white.svg`}
          />
        </div>
      </LayoutMain>
      <LayoutFooter type="device-fixed" _padding="xl">
        {showTryAgain ? (
          <Button _color="background" _size="lg" fullWidth onClick={onTryAgain}>
            {t('tryAgain')}
          </Button>
        ) : (
          <Text
            _text_size="sm"
            _text_align="center"
            style={{ fontFamily: 'arial' }}
            className={s.version}
          >
            {process.env.REACT_APP_VERSION}
          </Text>
        )}
      </LayoutFooter>
    </Layout>
  );
}

SplashScreen.propTypes = {
  showTryAgain: PropTypes.bool,
  onTryAgain: PropTypes.func,
};

SplashScreen.defaultProps = {
  showTryAgain: false,
  onTryAgain: () => {},
};

export default memo(SplashScreen);
